import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import '../../styles/welcomeToast.css';

const RocketIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '28px', height: '28px', color: '#ffc107' }}>
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
    </svg>
);

const WelcomeToast = () => {
    const { user, profile } = useAuth();
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (user && profile) {
            const hasSeen = sessionStorage.getItem(`welcome_${user.id}`);
            if (!hasSeen) {
                setShow(true);
                sessionStorage.setItem(`welcome_${user.id}`, 'true');
            }
        }
    }, [user, profile]);

    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                setShow(false);
            }, 10000); // 10 seconds
            return () => clearTimeout(timer);
        }
    }, [show]);

    if (!show) return null;

    const name = profile?.full_name?.split(' ')[0] || 'Explorer';

    return (
        <div className="welcome-toast-container">
            <div className="welcome-toast-content">
                <span className="welcome-toast-icon"><RocketIcon /></span>
                <div className="welcome-toast-text">
                    <h4>Welcome aboard, {name}!</h4>
                    <p>Your journey into the cosmos of creation begins now.</p>
                </div>
                <button className="welcome-toast-close" onClick={() => setShow(false)}>×</button>
            </div>
        </div>
    );
};

export default WelcomeToast;
